import React from "react";
import "./blogs.css";

const Sandipan = () => {
  return (
    <div className="blog">
      <div className="row blog-row">
        <div className="col-md-4">
          <img
          class="blog-image-right"
          style={{ height: "355px", width: "90%" }}
          src="/placement-postulates/blogs/Sandipan/6.JPG"
          alt="Sandipan"
        />
        </div>
        <div className="col-md-8">
          <div className="blog-head">
            <h2>Sandipan</h2>
            <small>Associate Data Scientist at Kotak Mahindra Bank</small>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row blog-row">
          <div className="col--md-12">
            <h3>Introduction </h3>
            <p>
              Hi everyone! I’m Sandipan, a Y21 BT/CE student, currently working as an Associate Data Scientist at Kotak Mahindra Bank Limited. In this post, I’d like to share some key moments from my first six semesters and my placement journey. While parts of this experience are uniquely mine, I believe many readers will find something to relate to — and hopefully, something to take away.

            </p>
          </div>
        </div>
        <img
          class="blog-image-right"
          style={{ height: "345px", width: "32%" }}
          src="/placement-postulates/blogs/Sandipan/1.jpg"
          alt="Sandipan"
        />

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>LIFE BEFORE INTERNSHIP</h3>
            <p>
              To begin with, I never had a natural inclination toward coding. My first real exposure came through ESC101, and it was only after seeing everyone around me immersed in coding that I decided to give it a try. I explored DSA, competitive programming, and platforms like LeetCode, but I quickly realized I couldn’t sustain the interest. It felt like rejoining another race after JEE Advanced — something I had no desire to repeat.

            </p>

            <p>
              As internship season approached, every online assessment I gave left me more certain that this path wasn’t for me. I thoroughly enjoyed studying and began considering higher studies instead. When the internship registration opened, I clearly saw any corporate internship as a backup to my research plans. In hindsight, listing “Academics” as my top preference may have cost me shortlists in several companies despite a decent CPI.
            </p>
            <p>
              By the end of November 2023, I had sent over 500 emails to professors across 50 universities, seeking a research internship. Meanwhile, I secured interview calls from JSW Cement and Indxx Capital. JSW Cement was my first-ever interview, and though I made mistakes, it taught me valuable lessons. A week later, I cleared my Indxx Capital interview and secured the backup I’d been hoping for.

            </p>
            <p>
              As December drew to a close, I faced disappointment when MITACS released their offers — and my name was missing. At that moment, I truly understood how uncertain this process can be. I felt grateful that I at least had an internship to fall back on.

            </p>
          </div>
        </div>

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>PLACEMENT SEMESTER</h3>
            <p>
              After completing my summer internship and returning for my seventh semester, I noticed a visible shift. Everyone was fine-tuning resumes, building projects, and practicing DSA. The same question resurfaced for me: should I give DSA another chance?

            </p>
            <p>
             I did — for a week. Then I faced the same realization. DSA wasn’t where my strength or interest lay. Instead, I decided to double down on data science, machine learning, SQL, and probability to position myself for Analyst roles. I strongly believe that during placements, it’s better to master one domain than to be average across many.

            </p>
            <p>One thing that I did back then, and I heavily recommend all the readers to do as well, is to get your resume verified by as many seniors as possible. If possible, ask seniors who have corporate experience. I had some Y17, 18 and 19 contacts, and I endlessly kept pinging them to suggest corrections in my resume (I am deeply thankful to them all for bearing with me).
            </p>
            <p>Another crucial factor was having a supportive peer group. At times, the process felt draining — failed tests, buggy projects, or back-to-back rejections can wear you down. Having friends with similar goals helped me stay motivated and balanced. The truth is, it’s hard to go through placements alone. Sometimes you’ll lift others up; sometimes they’ll lift you.
            </p>
          </div>
        </div>
        <br />
        <br />
        <br />
        
        <div className="row blog-row">
          <div className="col-md-12">
            <img
          class="blog-image-right"
          style={{ height: "355px", width: "40%" }}
          src="/placement-postulates/blogs/Sandipan/2.jpg"
          alt="Sandipan"
        />
            <h3>ONLINE ASSESSMENTS</h3>
            <p>
              Online assessments (OAs) are the first real hurdles in placements — and managing them is a skill in itself. The simplest yet most practical advice I can give is: track every OA carefully. Toward the end of the semester, deadlines fly by fast amid coursework and constant announcements. I personally missed out on giving the OAs for companies like Axxela and Mastercard, because either I was preoccupied with some course assignment, or I simply missed on the deadline to fill the form. Have your friends constantly keep updating you with any new notice on the portal, and do the same to them. 
            </p>
            <p>
             With the new technical advancements and strong cooperation skills, I did have a feeling that giving all these OAs was worthless because eventually everyone would have the same result. But I would still encourage you all to not get demotivated, and take it all as a learning lesson. After all, you only experience this phase once or twice in life, so make the most of it.

            </p>
            <p>
              As December 1st approaches, gradually shift focus from OAs to interview readiness. In the end, how you perform in those few interview opportunities makes all the difference.
            </p>
          </div>
        </div>
        
        <div className="row blog-row">
          <div className="col-md-12">
            <img
          class="blog-image-left"
              style={{ height: "355px", width: "35%" }}
          src="/placement-postulates/blogs/Sandipan/3.JPG"
          alt="Utkarsh"
        />
            <h3>Immense ups and downs - Day 1 and Day 2</h3>

            <h4>Shortlists</h4>
            <p>
              I only had interview shortlists in Microsoft (1.1), Indus Insights (1.2), Kotak(2.2), and Shiprocket (4). It was terrifying to realize that I had only four chances to prove myself. To make matters tougher, three of them required skills I wasn’t most confident in. For the third time, I faced the dilemma of whether to prepare DSA for Microsoft or not. I went on to spend the entirety of 30th November solving previously asked questions, but clearly the lack of practice showed, because at that point, I was more of memorizing the solutions, than understanding them.
            </p>
             <h4>1.1</h4>
            <p>
              My interview began at 1 a.m. on December 1st. It lasted a couple of hours and involved a leetcode medium question (Moore’s Voting Algorithm), followed by topics on networks and system design. My lack of practice was evident, and it didn’t go as I’d hoped. I returned to my room at 4 a.m., disappointed but aware that I had another interview just hours away.

            </p>
             <h4>1.2</h4>
            <p>The process with Indus Insights included two rounds on probability, a case study, and an HR discussion. I cleared all rounds and felt confident and relieved. However, the relief was very short-lived, as it so happened that Indus did not roll out offers to anyone due to some internal issues.  It was a tough blow, especially after the Microsoft setback. Tired, helpless, and distraught, I went back to my room, knowing that Kotak was now my only realistic chance left, as Shiprocket was hiring for an SDE role as well.
            </p>

             <h4>2.1</h4>
            <p>
                I had no shortlists for 2.1 and spent the night discouraged, wondering if it was time to accept defeat. I was unable to move on from the haunting memories of messing up the Microsoft interview and then getting politically bullied out of Indus Insights.
            </p>

             <h4>2.2- D-Day</h4>
            <p>
                Determined to give it one final push, I walked into my Kotak interview ready for anything. They were supposed to take only one round of interview, which was scheduled at 12pm for me. I was amongst the first few candidates to be interviewed, and it was excellent for me - possibly the best interview I have ever had. There were 2 SQL questions, 3-4 probability questions and a couple of puzzles. I managed to solve them all, and the following resume grilling was also not very harsh on me.

            </p>
            <hr/>
            <p>

                I stepped out very happy, knowing that I had very high chances of selection here. They soon announced that they would be taking two rounds instead of one, and that they would be giving out offers to only three candidates. I sat there, waiting for my second round call. All of a sudden, there was a commotion - two people were given offers. There was a sudden change in my mental state - it shifted from excitedly waiting for my second round to now a complete state of panic.
            </p>        
            <p>
                I was eventually called in. The second round interviewer asked questions on probability, basic concepts of linear and logistic regression, made me derive the closed form solution of linear regression, and followed it with a detailed case study round based off of A/B Testing. I wasn’t entirely sure of my performance but waited anxiously outside for hours, not even able to eat. By evening, with my phone battery dying and hope dwindling, I gave up, and started treading back to my room disappointed, for what would be the third time in 36 hours.
            </p>    
            <p>
                I was at the gate of my hall, when I received a call and was asked to come to the interview wing. I rushed there and was greeted by a single word - “Congratulations!”. That single word remains one of the happiest moments of my life so far. The feeling of having finally made it started to sink in. I finally did not have to go to sleep, disappointed with myself. I had successfully made it out of the most intense 36 hours of my life. 
            </p>        
          </div>
        </div>

        <div className="row blog-row">
          <div className="col-md-12">
            <img
          class="blog-image-right"
          style={{ height: "355px", width: "30%" }}
          src="/placement-postulates/blogs/Sandipan/5.JPG"
          alt="SANDIPAN"
        />
            <h3>Beyond the Offer: Lessons Learned</h3>
            <li>
                <h5>Preparation is paramount, but adaptability is key:</h5>
                 Technical knowledge builds your foundation, but adaptability defines your progress. Adjust quickly to changes instead of resisting them.The ability to quickly incorporate any unfavourable change and work towards a solution, instead of whining about why it happened, will most likely set you apart from the others.

            </li>
            <li>
                <h5>Networking matters:</h5> Building connections with seniors, alumni, and even company representatives can open doors you never knew existed. You never know, when that one person who knows someone you know, can be of immense help to you. It could be something as small as getting a point on your resume right, to something as important as a referral.
            </li>
            <li>
                <h5>Resilience is your superpower:</h5> Rejection is inevitable, but how you bounce back defines your journey. If you are given 10 opportunities, the world will allow you to fail 9 times, as long as you can succeed once. That one success is all you need.
            </li>   
            <li>
                <h5>Authenticity wins:</h5> Be genuine, even if that means being imperfect. Authenticity is sustainable; pretense isn’t.</li>
            <li>
                <h5>The IIT Tag is a privilege, not a guarantee: </h5>  Think of it as an elevator that takes you to the 10th floor in a race to reach the 20th. The finish line will not come down to the 10th floor for you. The rest of the climb is still yours to make.
             </li>
             <p>
             To all current and future IITians — cherish the placement journey. It will test your patience, confidence, and resilience, but it will also shape you in ways no course ever can. Good luck, and may your story be just as fulfilling and unforgettable as mine.
            </p>
           
          </div>
        </div>
        <img
          class="blog-image-right"
          style={{ height: "305px", width: "30%" }}
          src="/placement-postulates/blogs/Sandipan/4.JPG"
          alt="sandipan"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>SPECIAL MENTIONS</h3>
            <p>
              There are many people who played a meaningful role in my placement journey. It’s impossible to name everyone, but if I do miss someone, please know that you are very much a part of this story too.
            </p>
            <p>
              To my wingmates – Yuvraj, Vedant, Akshat, Aakash, and Udhav – I genuinely couldn’t have done this without you. Your support, humor, and motivation kept me going through the toughest days.
              </p>
            <p>
              And to the amazing group I found within the department, which once felt so distant – Shrey, Shruti, Shishir, and Shambhavi – thank you for being there when I needed you the most. You all turned what could have been an exhausting journey into one filled with warmth, laughter, and resilience.

            </p>
            <p>
             Looking back, I know in my heart that I could never have made it through this rollercoaster without all of you by my side. You are the reason this journey became not just a challenge, but a memory I will always treasure.

            </p>
           
          </div>
        </div>
        
        
      </div>
    </div>
  );
};

export default Sandipan;
